import React, { useEffect, useRef, useState } from 'react';
import { Card, Row, Col, Modal, Button, Badge, InputGroup, Form, FormLabel, CloseButton } from 'react-bootstrap';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/es';
import classNames from 'classnames';
import { getCoreRowModel } from '@tanstack/react-table';
import { getExpandedRowModel } from '@tanstack/react-table';
import { useReactTable } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';
import { getPaginationRowModel } from '@tanstack/react-table';
import { getFilteredRowModel } from '@tanstack/react-table';
import { GoogleMapsProvider } from '../../../../../providers/GoogleMapsProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from '../../../../../components/common/IconButton';
import { faExternalLinkAlt, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import GoogleMapSelector, { iconPuntoF, iconPuntoI } from '../../../../../components/common/google-maps-selector/GoogleMapSelector';
import AlertaVehiculoTableList from '../../../reporte_usabilidad/components/table-alerts/table-alerts.js';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaFileExport, FaMapMarkerAlt } from 'react-icons/fa';
import iconoPng from '../../../../../assets/img/icons/export.png';
import Spinner from 'react-bootstrap/Spinner';
import * as XLSX from 'xlsx';
import { obtenerIconoEvento } from '../../../../../components/common/google-maps-selector/IconosTabla';
import { ReporteRecorridoService } from '../../../../../services/apiService';
import { QURO_MAP_CONFIG } from '../../../../../config/apiConfig';
import { generateExcelReport } from '../../../../../helpers/createExcelReport';
import { obtenerLinkMapa } from '../../../../../helpers/utils.js';

// Activamos el soporte para formatos personalizados
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es');

const formatFecha = (fechaStr) => {
    if (!fechaStr || typeof fechaStr !== 'string') return 'N/A';

    try {
        return dayjs(fechaStr, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm');
    } catch (error) {
        console.error('Error al formatear la fecha:', error);
        return 'N/A';
    }
};

const formatFechaMasterData = (fechaStr) => {
    if (!fechaStr || typeof fechaStr !== 'string') return 'N/A';

    try {
        return dayjs(fechaStr, 'YYYY/MM/DD HH:mm:ss').format('DD/MM/YYYY HH:mm');
    } catch (error) {
        console.error('Error al formatear la fecha:', error);
        return 'N/A';
    }
};

const TableNonWorkingHours = ({ data = [], title, isGroup, geocercas = [], searchValue = '', onSearch, pageSize = 100, isExporting = false, onExport, selectedVehicle }) => {

    const safeTableData = Array.isArray(data) ? data : [];

    // Estado para manejar el modal del mapa
    const [globalFilter, setGlobalFilter] = useState(searchValue);
    const [expanded, setExpanded] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [showAlertasModal, setShowAlertasModal] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [track, setTrack] = useState([]);
    const [markers, setMarkers] = useState([]);
    const [selectedVehicleAlerts, setSelectedVehicleAlerts] = useState([]);
    // Mapa para asignar colores a cada tipo de alerta
    const alertColorsRef = useRef(new Map());
    const usedColors = new Set();

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: pageSize,
    });

    const [tokenQuro, setTokenQuro] = useState('');
    const [fechaInicial, setFechaInicial] = useState(Date.now());
    const [fechaFinal, setFechaFinal] = useState(Date.now());
    const [idVehiculo, setIdVehiculo] = useState(0);
    const [uidVehiculo, setUidVehiculo] = useState('');
    const obtenerTokenQuro = async () => {

        const response = await ReporteRecorridoService.getTokenConexionQuro()
        if (response && response.statusCode === 200) {

            if (response.data != null && response.data.length != 0) {
                setTokenQuro(response.data)
            } else {

                setTokenQuro('')
            }

        }
    }

    const handleClickAbrirRecorrido = () => {

        obtenerTokenQuro()
    }

    useEffect(() => {

        if (tokenQuro.length > 0) {

            const _fechaCargaInicial = dayjs(fechaInicial).format('YYYY-MM-DDTHH:mm:ss')
            const _fechaUltimaCarga = dayjs(fechaFinal).format('YYYY-MM-DDTHH:mm:ss')

            const _redirect = `Uid=${uidVehiculo}&fecha_carga_inicia=${_fechaCargaInicial}&Fecha_Ultima_Carga=${_fechaUltimaCarga}`

            const mapUrl = obtenerLinkMapa(_redirect, QURO_MAP_CONFIG.BASE_URL);

            if (mapUrl) {
                window.open(mapUrl);
            }
        }
    }, [tokenQuro])

    // Función para abrir el modal con la latitud y longitud seleccionadas
    const handleShowMap = (track, markers, points) => {
        if (track !== undefined) {
            if (points.children) {
                setFechaInicial(dayjs(points.children[0].fechaInicio, 'YYYY/MM/DD HH:mm:ss'));
                setFechaFinal(dayjs(points.children[points.children.length - 1].fechaFin, 'YYYY/MM/DD HH:mm:ss'));
            } else {
                setFechaInicial(dayjs(points.fechaInicio, 'YYYY/MM/DD HH:mm:ss'));
                setFechaFinal(dayjs(points.fechaFin, 'YYYY/MM/DD HH:mm:ss'));
            }
            setIdVehiculo(points.vehiculoId)
            setUidVehiculo(points.vehiculoUid)
            setSelectedLocation({ ...track[0], zoomLevel: 14 });
            setTrack(track);
            setMarkers(markers);
            setShowMapModal(true);
        }
    };

    // Estructura de columnas 
    const TabTitle = ({ amount, percentage, type, updown, action, width }) => (
        <div className="d-flex flex-nowrap justify-content-sm-between">
            <span className="fw-bold label-detail-card pt-1 " style={{ minWidth: width || '90px' }}>{amount}</span>
            <span
                className={classNames('fw-bold label-detail-card fs-11 pt-1 mb-0 text-nowrap', {
                    'text-alert-movement': type === 'up',
                    'text-alert-off': type === 'down',
                    'text-primary': type === 'standard',
                    'text-alert-detained': type === 'warning',
                    'text-info': type === 'pending'
                })} style={{ flex: '0 1 auto' }}
            >

                <Badge style={{ width: 60, height: 30 }} pill bg="transparent" className={`fw-semibold label-detail-card`}>
                    <a
                        className={classNames('mx-1 fw-semibold label-detail-card', {
                            'text-alert-movement': type === 'up',
                            'text-alert-off': type === 'down',
                            'text-primary': type === 'standard',
                            'text-alert-detained': type === 'warning',
                            'text-info': type === 'pending'
                        })}
                        href="#!" onClick={action}
                    >
                        {percentage}
                    </a>
                </Badge>

            </span>
        </div>
    );
    const style1Lines = {
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    const columns = [
        {
            header: ' ',
            cell: ({ row }) => {
                return row.getCanExpand() ?
                    <div>
                        <IconButton
                            variant="falcon-default"
                            size="sm"
                            icon={row.getIsExpanded() ? "chevron-up" : "chevron-down"}
                            transform="shrink-3"
                            onClick={row.getToggleExpandedHandler()}
                        />
                    </div>
                    :
                    <div style={{ width: 42, maxWidth: 42 }} />;
            },
        },
        {
            accessorKey: 'vehiculo',
            header: 'Vehículo',
            cell: ({ row }) => {
                // className="text-800"
                return row.getCanExpand() ? <Row>
                    <Col className="fw-bold label-detail-card pt-1">
                        <span
                            style={{ ...style1Lines, minWidth: '80px' }}
                            title={row.original.vehiculo} >
                            {row.original.vehiculo}
                        </span>
                    </Col>
                </Row> : <div></div>;
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'chofer',
            header: 'Chofer',
            cell: ({ row }) => {
                return row.getCanExpand() ? <Row>
                    <Col className="fw-bold label-detail-card pt-1">
                        <span
                            style={{ ...style1Lines, minWidth: '200px' }}
                            title={row.original.chofer} >
                            {row.original.chofer}
                        </span>
                    </Col>
                </Row> :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span> Encendido </span>
                            </Col>
                        </Row> :
                        <Row style={{ width: '240px' }}>
                            <Col>
                                <span className='label-detail-card'>

                                    {formatFecha(row.original.fechaInicio)}
                                </span>
                            </Col>
                        </Row>
                    ;
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'fechaInicio',
            header: 'Fecha inicio',
            cell: ({ row }) => {

                return row.getCanExpand() ?
                    <Row md={12} className="flex-nowrap" style={{ maxWidth: '200px' }}>
                        <span className='fw-bold label-detail-card text-nowrap mx-0' style={{ width: '200px' }}

                            title={formatFechaMasterData(row.original.fechaInicio)}>
                            {formatFechaMasterData(row.original.fechaInicio)}
                        </span>
                    </Row>
                    :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span> Apagado </span>
                            </Col>
                        </Row> :
                        <Row style={{ width: '240px' }}>
                            <Col >
                                <span className='label-detail-card'>
                                    {/* className="text-600"  */}
                                    {formatFecha(row.original.fechaFin)}
                                </span>
                            </Col>
                        </Row>;
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'fechaFin',
            header: 'Fecha fin',
            cell: ({ row }) => {

                return row.getCanExpand() ?
                    <Row style={{ maxWidth: '200px' }}>
                        <Col >
                            <span className='fw-bold label-detail-card text-nowrap mx-0' style={{ width: '200px' }}

                                title={formatFechaMasterData(row.original.fechaFin)}>
                                {formatFechaMasterData(row.original.fechaFin)}
                            </span>
                        </Col>
                    </Row>
                    :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span> Tiempo </span>
                            </Col>
                        </Row> :
                        <Row style={{ width: '200px' }}>
                            <Col >
                                <span className='label-detail-card'>
                                    {/* className="text-600" */}
                                    {row.original.tiempo}
                                </span>
                            </Col>
                        </Row>;
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'tiempo',
            header: 'Total de horas',
            cell: ({ row }) => {
                return row.getCanExpand() ?
                    <Row className="flex-nowrap ">
                        <span className='fw-bold label-detail-card text-nowrap mx-0' style={{ width: '200px' }}
                            // text-800
                            title={row.original.tiempo} >
                            {row.original.tiempo}
                        </span>
                    </Row>
                    :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span>Distancia</span>
                            </Col>
                        </Row> :
                        <Row>
                            <Col >
                                <span className='label-detail-card'>
                                    {/* className="text-600"  */}
                                    {parseFloat(`${row.original.distancia}`).toFixed(2)} km
                                </span>
                            </Col>
                        </Row>;
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: "mapa",
            header: "Ver recorrido",
            cell: ({ row }) => {

                return row.getCanExpand() ?
                    <Row>
                        <Col className="fw-bold">
                            {/* <TabTitle
                                amount={`${(row.original.distancia || 0).toFixed(2)} km`}
                                percentage={'Ver'}
                                type='pending'
                                action={() => handleShowMap(
                                    row.original.track ?? [],
                                    row.original.markers,
                                    row.original
                                )}
                                width={"10px"}
                            /> */}

                            <a
                                size="sm"
                                className="p-1"
                                href='#!'
                                transform="shrink-3"
                                onClick={() => handleShowMap(
                                    row.original.track ?? [],
                                    row.original.markers,
                                    row.original
                                )}
                            >
                                <FaMapMarkerAlt className="text-danger" />
                            </a>
                        </Col>
                    </Row>
                    :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span>
                                    Mapa
                                </span>
                            </Col>
                        </Row> :
                        <div className='text-left'>
                            <a
                                size="sm"
                                className="p-1"
                                href='#!'
                                transform="shrink-3"
                                onClick={() => handleShowMap(
                                    row.original.track ?? [],
                                    [],
                                    row.original
                                )}
                            >
                                <FaMapMarkerAlt className="text-danger" />
                            </a>
                        </div>;
            },
            meta: {
                headerProps: { className: "text-900 text-center" },
                cellProps: { className: "text-center" },
            },
        },
        {
            accessorKey: "totalAlertas",
            header: "Alertas",
            cell: ({ row }) => {
                return row.getCanExpand() ?
                    <Row href="#!">
                        <Col style={{ fontWeight: 'bold' }} className="fw-bold">
                            <TabTitle
                                amount={`${row.original.totalAlertas.length}`}
                                percentage={'Ver'}
                                updown={1}
                                type='pending'
                                action={() => {
                                    setSelectedVehicleAlerts(row.original.totalAlertas);
                                    setShowAlertasModal(true);
                                }}
                                width={'40px'}
                            />
                        </Col>
                    </Row>
                    :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span>
                                </span>
                            </Col>
                        </Row> :
                        '';
            },
            meta: {
                headerProps: { className: "text-900 text-center" },
                cellProps: { className: "text-center", },
            },
        }

        // {
        //     accessorKey: "mapa",
        //     header: "Distancia Recorrida",
        //     cell: ({ row }) => {
        //         // LOG: Mostrar datos usados para el cálculo de distancia recorrida
        //         console.log('Distancia Recorrida - row.original:', row.original);
        //         return row.getCanExpand() ?
        //             <Row>
        //                 <Col>
        //                     <TabTitle
        //                         amount={`${(row.original.distancia).toFixed(3)} KM`}
        //                         percentage={'Abrir'}
        //                         type='pending'
        //                         action={() => handleShowMap(
        //                             row.original.track ?? [],
        //                             row.original.markers
        //                         )}
        //                     />
        //                 </Col>
        //             </Row>
        //             :
        //             <div className='text-center'>
        //                 <a
        //                     size="sm"
        //                     className="p-1"
        //                     href='#!'
        //                     transform="shrink-3"
        //                     onClick={() => handleShowMap(
        //                         row.original.track ?? [],
        //                         []
        //                     )}
        //                 >
        //                     <FaMapMarkerAlt className="text-danger" />

        //                 </a>
        //             </div>;
        //     },
        //     meta: {
        //         headerProps: { className: "text-900 text-center" },
        //         cellProps: { className: "text-center" },
        //     },
        // },
        // {
        //     accessorKey: "totalAlertas",
        //     header: "",
        //     cell: ({ row }) => {
        //         return row.getCanExpand() ?
        //             <Row href="#!">
        //                 <Col style={{ fontWeight: 'bold' }} className="fw-bold">
        //                     <TabTitle
        //                         amount={`${row.original.totalAlertas.length}`}
        //                         percentage={'Ver'}
        //                         updown={1}
        //                         type='pending'
        //                         action={() => {
        //                             setSelectedVehicleAlerts(row.original.totalAlertas);
        //                             setShowAlertasModal(true);
        //                         }}
        //                         width={'40px'}
        //                     />
        //                 </Col>
        //             </Row>
        //             :
        //             row.original.header === true ?
        //                 <Row>
        //                     <Col className="fw-bold label-detail-card pt-1">
        //                         <span>
        //                         </span>
        //                     </Col>
        //                 </Row> :
        //                 '';
        //     },
        //     meta: {
        //         headerProps: { className: "text-900 text-center" },
        //         cellProps: { className: "text-center", },
        //     },
        // }
    ]

    const table = useReactTable({
        data: safeTableData,
        columns,
        sortable: true,
        pagination: true,
        state: {
            globalFilter,
            pagination,
        },
        onGlobalFilterChange: setGlobalFilter,
        onPaginationChange: setPagination,
        getPaginationRowModel: getPaginationRowModel(),
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSubRows: (row) => row.children,
        getExpandedRowModel: getExpandedRowModel(),
        enableSorting: true,
        enableGlobalFilter: true,
        debugTable: false,
        enableColumnFilters: false
    });

    // Manejar el cambio en la búsqueda global
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setGlobalFilter(value);
        if (onSearch) onSearch(value);
        // Resetear a la primera página cuando se busca
        setPagination(prev => ({ ...prev, pageIndex: 0 }));
    };

    // Sincronizar el filtro global con el searchValue recibido por props
    React.useEffect(() => {
        setGlobalFilter(searchValue);
    }, [searchValue]);

    const Filter = function ({ column, table }) {
        const firstValue = table
            .getPreFilteredRowModel()
            .flatRows[0]?.getValue(column.id)
        const columnFilterValue = column.getFilterValue()

        return typeof firstValue === "number" ? (
            <div className="flex space-x-2">
                <input
                    type="number"
                    value={columnFilterValue?.[0] ?? ""}
                    onChange={e => column.setFilterValue(old => [e.target.value, old?.[1]])}
                    placeholder={`Min`}
                    className="w-24 border shadow rounded"
                />
            </div>
        ) : (
            <input
                type="text"
                value={columnFilterValue ?? ""}
                onChange={e => column.setFilterValue(e.target.value)}
                placeholder={`Search...`}
                className="w-36 border shadow rounded"
            />
        )
    }

    const getUniqueColor = () => {
        let newColor;
        do {
            newColor = `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
        } while (usedColors.has(newColor)); // Asegurar que el color no esté en uso
        usedColors.add(newColor);
        return newColor;
    };

    const getAlertColor = (alertType) => {
        if (!alertColorsRef.current.has(alertType)) {
            const newColor = getUniqueColor();
            alertColorsRef.current.set(alertType, newColor);
        }
        return alertColorsRef.current.get(alertType);
    };

    const handleExportToExcel = async () => {

        try {
            if (window['guardarBitacoraExport']) {
                try {
                    window['guardarBitacoraExport']();
                } catch (error) {

                }
            }

            //Columnas del reporte 
            let columns = [
                'Vehiculo',
                'Fecha Inicio',
                'Fecha Fin',
                'Tiempo',
                'Distancia'
            ]

            // Agregar maestro-detalle 
            let dataReport = [];

            safeTableData.forEach((grupo, index) => {

                //Detallado por vehiculo 
                let subList = [];

                // Filas de detalles
                grupo.children.forEach(detalle => {

                    const distancia = parseFloat(detalle.distancia?.toString() || 0).toFixed(2).toString() + ' Km';

                    subList.push([
                        detalle.vehiculo?.toString() || "N/A",
                        detalle.fechaInicio?.toString() || "N/A",
                        detalle.fechaFin?.toString() || "N/A",
                        detalle.tiempo?.toString() || "N/A",
                        distancia || "N/A",
                    ]);
                });

                //maestro
                let masterData =
                {
                    titulo: `Vehiculo: (${grupo.vehiculo})  |  Tiempo usabilidad fuera de horario:  ${grupo.tiempo} `,
                    detalles: subList
                }

                //Agrega el maestro a la lista de informacion
                dataReport.push(masterData);
            });

            //Exportar reporte 
            generateExcelReport('Reporte Horarios', dataReport, true, columns);

        } catch (error) {
            console.error("Error al exportar a Excel:", error);
        }
    };

    return (
        <Card className="h-100" >
            <Card.Header>

                <Row className='d-flex align-items-center justify-content-between'>
                    <Col md={6}>
                        <h6 className="mb-0 text-nowrap py-2 py-xl-0">{title}</h6>
                    </Col>

                    <Col md={4} className="d-flex justify-content-end align-items-center">

                        <Button
                            variant="primary"
                            size="sm"
                            className="me-2 p-2"
                            onClick={handleExportToExcel}
                            disabled={isExporting}
                        >
                            {isExporting ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-1"
                                    />
                                    Exportando...
                                </>
                            ) : (
                                <>
                                    <img
                                        src={iconoPng}
                                        alt="Exportar" title='Exportar a Excel'
                                        style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} // Ajusta el tamaño
                                        className="me-1 ms-1"
                                    />
                                </>
                            )}
                        </Button>

                        <InputGroup size="sm" style={{ maxWidth: 200 }} >

                            <Form.Control
                                className='p-2'
                                type="text"
                                placeholder="Buscar..."
                                value={globalFilter || ''}
                                onChange={handleSearchChange}
                            />
                            {globalFilter && (
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setGlobalFilter('');
                                        if (onSearch) onSearch('');
                                    }}
                                >
                                    &times;
                                </Button>
                            )}

                        </InputGroup>

                    </Col>

                    <Col md={2}>
                        <Form className='d-flex p-2 justify-content-end'>
                            <Form.Select
                                className='p-2'
                                size="sm"
                                style={{ width: '100px' }}
                                value={table.getState().pagination.pageSize}
                                onChange={e => {
                                    table.setPageSize(Number(e.target.value))
                                }}
                            >
                                {[5, 10, 20, 30, 40, 50].map(pageSize => (
                                    <option key={pageSize} value={pageSize}>
                                        {pageSize}
                                    </option>
                                ))}
                            </Form.Select>

                        </Form>
                    </Col>
                </Row>
            </Card.Header>

            <Card.Body className='mt-0 pt-0 ms-0 me-0 ps-0 pe-0'>
                <div style={{ overflow: 'auto' }}>
                    <GoogleMapsProvider>
                        <table className='fs-10 mb-0 overflow-hidden table table-striped'>
                            <thead className='text-nowrap align-middle'>
                                {table.getHeaderGroups().map(headerGroup => (
                                    <tr key={headerGroup.id}>
                                        {headerGroup.headers.map(header => {
                                            return (
                                                <th key={header.id} colSpan={header.colSpan}>
                                                    {header.isPlaceholder ? null : (
                                                        <div>
                                                            {flexRender(
                                                                header.column.columnDef.header,
                                                                header.getContext()
                                                            )}

                                                            {header.column.getCanFilter() ? (
                                                                <div>
                                                                    <Filter column={header.column} table={table} />
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    )}
                                                </th>
                                            )
                                        })}
                                    </tr>
                                ))}
                            </thead>
                            <tbody>
                                {table.getRowModel().rows.map(row => {
                                    return (
                                        <tr key={row.id}>
                                            {row.getVisibleCells().map(cell => {
                                                return (
                                                    <td key={cell.id}>
                                                        {flexRender(
                                                            cell.column.columnDef.cell,
                                                            cell.getContext()
                                                        )}
                                                    </td>
                                                )
                                            })}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>

                        {/* Modal para ver el mapa */}
                        <Modal
                            show={showMapModal}
                            onHide={() => setShowMapModal(false)}
                            size="lg"
                            centered
                        >
                            <Modal.Header className="d-flex justify-content-between align-items-center" >
                                <Modal.Title className="mb-0">
                                    Recorrido
                                </Modal.Title>

                                <div className='d-flex align-items-center gap-2'>
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        style={{
                                            backgroundColor: 'white',
                                            color: '#2c7be5'
                                        }}
                                        onClick={handleClickAbrirRecorrido}
                                    >
                                        <FontAwesomeIcon icon={faExternalLinkAlt} /> Abrir recorrido
                                    </Button>
                                    <CloseButton onClick={() => setShowMapModal(false)} />
                                </div>

                            </Modal.Header>
                            <Modal.Body>
                                <GoogleMapSelector
                                    className="vh-50"
                                    mapStyle="Default"
                                    initialCenter={selectedLocation}
                                    waypoints={track}
                                    markers={markers}
                                    geocercas={geocercas}
                                    zoomDefault={13}
                                    showStreetView={false}
                                />
                            </Modal.Body>
                        </Modal>

                        <Modal Modal
                            show={showAlertasModal}
                            onHide={() => setShowAlertasModal(false)}
                            size="xl"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Listado de Alertas GPS</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className='mt-0 pt-0 ms-0 me-0 ps-0 pe-0'>
                                <Col md={12}>
                                    {selectedVehicleAlerts.length > 0 && (
                                        <AlertaVehiculoTableList
                                            data={selectedVehicleAlerts.map(alert => ({
                                                ...alert,
                                                color: getAlertColor(alert.alerta) // Color persistente por alerta
                                            }))}
                                            title="Listado Alertas GPS"
                                            isGroup={true}
                                            perPage={5}
                                            geocercas={geocercas}
                                        />)
                                    }
                                </Col>
                            </Modal.Body>
                        </Modal>
                    </GoogleMapsProvider>
                </div>
            </Card.Body>

            <Card.Footer className="bg-white">


                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div className="d-flex align-items-center">
                        <span className="me-2">
                            Total: {table.getFilteredRowModel().rows.length} | Página {table.getState().pagination.pageIndex + 1} de {table.getPageCount()}
                        </span>
                        <Form.Control
                            type="number"
                            min="1"
                            max={table.getPageCount()}
                            value={table.getState().pagination.pageIndex + 1}
                            onChange={e => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                table.setPageIndex(page);
                            }}
                            style={{ width: '70px', height: '31px' }}
                            size="sm"
                        />
                    </div>

                    <div className="d-flex justify-content-center">
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.setPageIndex(0)}
                            disabled={!table.getCanPreviousPage()}
                        >
                            <FaAngleDoubleLeft />
                            {/* &laquo; Primera */}
                        </Button>
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.previousPage()}
                            disabled={!table.getCanPreviousPage()}
                        >
                            <FaAngleLeft />
                            {/* &lt; Anterior */}
                        </Button>

                        {/* Mostrar números de página (5 páginas alrededor de la actual) */}
                        {(() => {
                            // Determinar qué páginas mostrar
                            let pagesArray = [];
                            if (table.getPageCount() <= 5) {
                                // Si hay 5 o menos páginas, mostrarlas todas
                                pagesArray = Array.from({ length: table.getPageCount() }, (_, i) => i);
                            } else if (table.getState().pagination.pageIndex <= 2) {
                                // Si estamos en las primeras páginas
                                pagesArray = [0, 1, 2, 3, 4];
                            } else if (table.getState().pagination.pageIndex >= table.getPageCount() - 3) {
                                // Si estamos en las últimas páginas
                                pagesArray = [
                                    table.getPageCount() - 5,
                                    table.getPageCount() - 4,
                                    table.getPageCount() - 3,
                                    table.getPageCount() - 2,
                                    table.getPageCount() - 1
                                ];
                            } else {
                                // Estamos en medio, mostrar 2 antes y 2 después
                                pagesArray = [
                                    table.getState().pagination.pageIndex - 2,
                                    table.getState().pagination.pageIndex - 1,
                                    table.getState().pagination.pageIndex,
                                    table.getState().pagination.pageIndex + 1,
                                    table.getState().pagination.pageIndex + 2
                                ];
                            }

                            return pagesArray.map(pageNum => (
                                <Button
                                    key={`page-${pageNum}`}
                                    variant={pageNum === table.getState().pagination.pageIndex ? "primary" : "outline-dark"}
                                    size="sm"
                                    className="mx-1"
                                    onClick={() => table.setPageIndex(pageNum)}
                                >
                                    {pageNum + 1}
                                </Button>
                            ));
                        })()}

                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.nextPage()}
                            disabled={!table.getCanNextPage()}
                        >
                            {/* Siguiente &gt; */}
                            <FaAngleRight />
                        </Button>
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                            disabled={!table.getCanNextPage()}
                        >
                            {/* Última &raquo; */}
                            <FaAngleDoubleRight />
                        </Button>
                    </div>
                </div>
            </Card.Footer>
        </Card>
    );
};

export default TableNonWorkingHours;